/*
MIT License

Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

export type ClassValue =
  | ClassArray
  | string
  | number
  | null
  | boolean
  | undefined;

interface ClassArray extends Array<ClassValue> {}

function toVal(mix: NonNullable<ClassValue>) {
  let k: string | number,
    y: string,
    str = '';

  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (Array.isArray(mix)) {
    for (k = 0; k < mix.length; k++) {
      if (mix[k]) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ((y = toVal(mix[k]!))) {
          str && (str += ' ');
          str += y;
        }
      }
    }
  }

  return str;
}

/**
 * Conditionally join strings of class names together, filtering out falsy values.
 *
 * @example
 * cssJoin('bg-secondary', variant === 'primary' && 'text-primary')
 *
 * @param classes
 */
export function cssJoin(...classes: ClassValue[]): string {
  let i = 0;
  let tmp: ClassValue;
  let x: string;
  let str = '';
  while (i < classes.length) {
    if ((tmp = classes[i++])) {
      if ((x = toVal(tmp))) {
        str && (str += ' ');
        str += x;
      }
    }
  }
  return str;
}
